import { useState, useEffect, useContext } from "react";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Image, Title3, Body1, Caption1, FluentProvider, webLightTheme, Card, Input, Tooltip, Spinner } from "@fluentui/react-components";
import { BoxCheckmark20Regular, UninstallApp20Regular, CheckboxCheckedSync20Regular, SquareHintApps20Regular, BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, Dismiss16Regular, FilterAdd20Filled, Info16Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { Install_Status_func } from "../../../api/app/app_install_status_func";
import { TroubleshooterDevice_fun } from "../../../api/troubleshoot/troubleshooterDevice_fun";
import { GlobalContext } from "../../../hooks/globalContext";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { Form } from "@rjsf/fluent-ui";
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';
import { fullscreenIcon, lightTheme, messageTheme, primaryIcon, exitIcon, overflowDivider, secondaryIcon, buttonContent, dividerWidthStyle, overflowScroll, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, oveyAlignment, childHome, overlayTableHeight, tableDiv, timezoneInfo, heightResponsive, dashboardTheme, BreadcrumbsBorder, overlayResponsive } from "../../../styles/customStyles";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
// import { convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import DialogBox from "../../../components/dialog/dialog.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { SkeletonOverlayDataTable } from "../../../components/skeleton/skeletonOverlayDataTable";
import { ManageAppPages } from "../../../components/side_menu/InlineSidenav";


export const Appinstallstatus = () => {

  const navigate = useNavigate();
  const handle = useFullScreenHandle();
  const contextValue: any = useContext(GlobalContext);
  var tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); const [final_data, set_final_data]: any = useState(null);
  const [final_data1, set_final_data1]: any = useState(null);
  const [final_data2, set_final_data2]: any = useState(null);
  const [final_data3, set_final_data3]: any = useState(null);
  // const [final_data3, set_final_data3]: any = useState(null);
  const [deviceList, setDeviceList]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchDevVal, setSearchDevVal] = useState("");
  const [groupName, setGroupName] = useState('');
  const [allDevice, setallDevice] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData1, setExportData1] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [rowID, setRowID]: any = useState(null);
  const [pacakgeName, setPackageName]: any = useState(null);
  const [rowDesc, setRowDesc]: any = useState(null);
  const [isToast, setIsToast] = useState(false);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [deployPackageDetails, setDeployPackageDetails]: any = useState(false)
  // const [dropDownValue1,setDropDownValue1] = useState<any[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [machineStatus, setMachineStatus]: any = useState({});
  const [tracker, setTracker] = useState(false);
  const [type, setType] = useState('Installation');
  const [pushClassification, setPushClassification]: any = useState();
  const [pushClassificationType, setPushClassificationType]: any = useState();
  const [pendingJob, setPendingJob]: any = useState(false);
  const [pending, setPending]: any = useState(false);
  const [previousJob, setPreviousJob]: any = useState(false);
  const [jobPush, setJobPush] = useState(false);
  const [jobFailed, setJobFailed] = useState(false)
  const [pendingJobMessage, setpendingJobMessage] = useState(false)
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [isOverlayFilter, setIsOverlayFilter] = useState(false);
  const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
  const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
  const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
  const [overlayFilterArray, setOverlayFilterArray] = useState<string[]>([]);
  const [isOverlayResetDisabled, setOverlayResetDisabled] = useState(true);

  const [uniqueOSPage, setUniqueOSPage] = useState([]);
  const [isOsNamePage, setOsNamePage] = useState([]);

  const [uniqueOS, setUniqueOS] = useState([]);
  const [isOsName, setOsName] = useState([]);

  const [totalOverlayPages, setTotalOverlayPages] = useState(1);
  const [currentOverlayPageNo, setCurrentOverlayPageNo] = useState(1);
  const [totalOverlayRecords, setTotalOverlayRecords] = useState(0);

  // const [permissions, setPermissions] = useState(['']);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [loadingDevice, setLoadingDevice] = useState(true);
  const [isSaveEnabled, setButtonEnabled] = useState(false);
  const [deviceDataWithStatus, setDeviceDataWithStatus]: any = useState({});

  const [formDataPkg, setFormDataPkg] = useState({});
  const [formDataApp, setFormDataApp] = useState({});
  const [formDataAdv, setFormDataAdv] = useState({});
  const [jsonSchemaPkg, setJsonDataPkg]: any = useState({});
  const [uiSchemaPkg, setUiDataPkg]: any = useState({});
  const [jsonSchemaApp, setJsonDataApp]: any = useState({});
  const [uiSchemaApp, setUiDataApp]: any = useState({});
  const [jsonSchemaAdv, setJsonDataAdv]: any = useState({});
  const [uiSchemaAdv, setUiDataAdv]: any = useState({});
  const [messagebar1, setmessagebar1] = useState(false);
  const [messagebar2, setmessagebar2] = useState(false);
  const [errorMessage, setErrorMessage] = useState<String>('')


  console.log("checing the PENDING+=", pendingJob)
  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    // Check if the column is already filtered
    const columnExists = filterArray.some(filter => filter.startsWith(`${value1} :`));
    if (!columnExists) {
      const result = value1 + " : " + value2;
      setFilterArray([...filterArray, result]);
      setIsFilter(true);
      setLoading(true);
      setDropDownValue1('');
      setDropDownValue2('');
    }
  };

  const handleCloseFilter = (index: any): any => {
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }

  useEffect(() => {
    setResetDisabled(filterArray.length > 0 ? false : true);
  }, [filterArray]);

  useEffect(() => {
    setOverlayResetDisabled(overlayFilterArray.length > 0 ? false : true);
  }, [overlayFilterArray]);

  useEffect(() => {
    setOsName(uniqueOS?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setOsNamePage(uniqueOSPage?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    console.log("uniqueOS", uniqueOS);
    console.log("uniqueOSpage", uniqueOSPage);
  }, [uniqueOS, uniqueOSPage]);

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_-]*$/;
    const regexN = /^[0-9\.]*$/;
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
      setErrorMessage(`${dropDownValue1} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
    if (name === 'filter' && dropDownValue1 === ("Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Version")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Description")) {
      if (regexS.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  const handleOverlayFilter = (): any => {
    const value1 = dropDownValue1Overlay;
    const value2 = dropDownValue2Overlay;
    const result = value1 + " : " + value2;
    setOverlayFilterArray([...overlayFilterArray, result])
    setIsOverlayFilter(true);
    setDropDownValue1Overlay('');
    setDropDownValue2Overlay('');
  }

  const handleCloseOverlayFilter = (index: any): any => {
    const updatedArray = overlayFilterArray.filter((x, itemIndex) => itemIndex !== index);
    setOverlayFilterArray(updatedArray);
    // setLoadingTable(true);
  }

  const overlayInputChange = (e: any) => {
    const enteredValue = e.target.value;
    let name = e.target.name;
    const regexSN = /^[A-Za-z0-9_-]*$/;
    if (overlayFilterArray.some((filter) => filter.startsWith(`${dropDownValue1Overlay} :`))) {
      setErrorMessage(`${dropDownValue1Overlay} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
    if (name === 'filter' && dropDownValue1Overlay === ("Device Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2Overlay(enteredValue);
      }
    }
  }

  useEffect(() => {
    setOverlayResetDisabled(overlayFilterArray.length > 0 ? false : true);
  }, [overlayFilterArray]);

  //for popup message
  const handleEditData = (data: any) => {
    const pkgDetails = JSON.parse(data?.data[0].formDataPkg)
    const appDetail = JSON.parse(data?.data[0].formDataApp)
    const advDetail = JSON.parse(data?.data[0].formDataAdv)
    setFormDataPkg(pkgDetails)
    setFormDataApp(appDetail);
    setFormDataAdv(advDetail);
  }

  const handleBothSetMessage = () => {
    setJobFailed(false)
    setJobPush(false)
    setmessagebar1(false);
    setmessagebar2(true);
    setPreviousJob(false)
    setDeployPackageDetails(true);
  };

  const handlePendingMessages = () => {
    setpendingJobMessage(false)
    setPendingJob(true);
    // setPending(false)
  }

  //data table column name code starts here
  // var columns = [
  //   { key: "name", label: <Body1Strong> Name </Body1Strong> },
  //   { key: "description", label: <Body1Strong>Description </Body1Strong> },
  //   { key: "version", label: <Body1Strong>Version</Body1Strong> },
  //   { key: "os", label: <Body1Strong>Operating System</Body1Strong> },
  //   { key: "created_on", label: <Body1Strong>Created On (UTC)</Body1Strong> },
  //   { key: "created_on_timezoned", label: <Body1Strong>Created On({formattedTimeZone})</Body1Strong> },
  //   { key: "modified_on", label: <Body1Strong>Modified On (UTC)</Body1Strong> },
  //   { key: "modified_on_timezoned", label: <Body1Strong>Modified On({formattedTimeZone})</Body1Strong> },
  //   // { key: "status", label: <Body1Strong>Status</Body1Strong> },
  // ];
  //data table column name code ends here

  //data table for filter starts here
  // var columns1 = [
  //   // { key: "pkgId", label: <Body1Strong> pkgName </Body1Strong> },
  //   { key: "names", label: <Caption1> Name </Caption1> },
  //   { key: "description", label: <Caption1>Description </Caption1> },
  //   { key: "version", label: <Caption1>Version</Caption1> },
  //   { key: "os", label: <Caption1>Operating System</Caption1> },
  //   { key: "created_on", label: <Caption1>Created On</Caption1> },
  //   { key: "modified_on", label: <Caption1>Modified On</Caption1> },
  //   // { key: "status", label: <Caption1>Status</Caption1> },
  // ];
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.apps?.App_Install_Status.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "created_on_timezoned" || val.key === "modified_on_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });
    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);
    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.apps?.App_Install_Status.filter((val) => val.priority >= 0));
    contextValue.setManageViewPageDetails({ module: "apps", page: "App_Install_Status" });
  }, [contextValue.tableColumnsData]);

  //overlay datatable code start here
  var overlayColumns = [
    { key: "host", label: <Body1Strong> Device Name</Body1Strong> },
    // { key: "site", label: <Body1Strong> Device Classification </Body1Strong> },
    { key: "os", label: <Body1Strong> Operating System </Body1Strong> },
  ];


  //overlay datatable code ends here
  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        {permissions.includes("all") || permissions.includes("appInstall_ReadandExport") || permissions.includes("appInstall_Fullaccess") ?
          <StackItem>
            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_installstatus_list.csv`}>
            </CSVLink>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true) }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <StackItem>
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Export </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          </StackItem>
        }

        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />}  </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here
  var tempTableData: any = [];
  var tempExportData: any = [];
  var tempTableData1: any = [];

  //////////////////////this is first page data table ///////////////////////////////
  useEffect(() => {
    if (allDevice && contextValue.selectedRowIdInTable.length === final_data1?.length) {
      setPushClassification("Classification")
      setPushClassificationType("All Devices");
    }
    else if (allDevice && contextValue.selectedRowIdInTable.length != final_data1?.length) {
      setPushClassification("Machine");
      setPushClassificationType("");
    }
    else if (!allDevice) {
      setPushClassification("Classification");
      setPushClassificationType(groupName);
    }
  }, [contextValue.selectedRowIdInTable])

  useEffect(() => {
    if (final_data1 !== undefined && final_data1 !== null) {
      const newUniqueOs: any = [];

      final_data1.forEach((val: any) => {
        // Ensure the OS name is valid and not already in the list
        if (val.os && val.os.trim() !== "-" && !newUniqueOs.includes(val.os)) {
          newUniqueOs.push(val.os);
        }
      });
      setUniqueOS(newUniqueOs);
      console.log("Unique operating System:", newUniqueOs);
    } else {
      setUniqueOS([]);
    }
  }, [final_data1]);

  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueOs: string[] = [];

      final_data?.forEach((val: any) => {
        console.log("val.platform", val.platform);
        if (val.platform && val.platform.trim() !== "-" && !newUniqueOs.includes(val.platform)) { newUniqueOs.push(val.platform); }
      });
      setUniqueOSPage(newUniqueOs);
    } else {
      setUniqueOSPage([]);
    }
  }, [final_data]);

  useEffect(() => {
    var tempExportData: any = [];

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
        tempExportData.push({
          "Name": val.packageName !== null ? val.packageName : 'N/A',
          "Description": val.packageDesc != "" ? val.packageDesc : 'N/A',
          "Created on": val.creationTime !== null ? convertToExcelFormat(val.creationTime) : '-',
          "Version": val.version,
          "Operating System": val.platform,
          "Modified On": (val.lastModified !== null) ? convertToExcelFormat(val.lastModified) : "-",
          "Status": val.status != null ? "Draft" : "Draft"
        });
    });
    // setExportBtnClicked(false);
    setExportData(tempExportData);
}, [exportDetails]);

useEffect(() => {
  const uniqueIds = new Set(); 
  const tempExportData: any[] = [];

  exportDetails?.forEach((val: any) => {
      if (!uniqueIds.has(val.app_packageId)) {
          uniqueIds.add(val.app_packageId);
          tempExportData.push({
            "Name": val.packageName !== null ? val.packageName : 'N/A',
            "Description": val.packageDesc != "" ? val.packageDesc : 'N/A',
            "Created on": val.creationTime !== null ? convertToExcelFormat(val.creationTime) : '-',
            "Version": val.version,
            "Operating System": val.platform,
            "Modified On": (val.lastModified !== null) ? convertToExcelFormat(val.lastModified) : "-",
          });
      }
  });

  setExportData(tempExportData);
}, [exportDetails]);

useEffect(() => {
  exportData.length > 0 && document.getElementById('csv-export-link')?.click();
}, [exportData]);

  useEffect(() => {
    console.log("final_data=", final_data);
    const uniqueIds = new Set(); // Set to store unique app_packageIds
    const updatedTempTableData = final_data !== undefined && final_data !== null
      ? final_data?.reduce((accumulator: any, val: any, i: any) => {
        if (!uniqueIds.has(val.app_packageId)) {
          uniqueIds.add(val.app_packageId); // Add app_packageId to the set

          {
            permissions.includes("all") || permissions.includes("appInstall_Fullaccess") ?
              accumulator.push({
                checkbox: "hide",
                name: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => { setRowID(val.id); setRowDesc(val.packageName); setOverlayOpen(true); setPackageName(val.packageName); setSpinnerLoad(true) }}> {val.packageName !== null ? val.packageName : 'N/A'} </Button>, id: `${i}` },
                description: { label: <Caption1 > {val.packageDesc != "" ? val.packageDesc : 'N/A'} </Caption1>, status: "" },
                version: { label: <Caption1> {val.version} </Caption1>, },
                os: { label: <Caption1> {val.platform} </Caption1>, },
                created_on: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertUTCToReadableFormat(val.creationTime) : '-'} </Caption1>, },
                created_on_timezoned: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertToLocalTimezone(val.creationTime, userTimeZone) : '-'} </Caption1>, },
                modified_on: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertUTCToReadableFormat(val.lastModified) : "-"}</Caption1>, },
                modified_on_timezoned: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertToLocalTimezone(val.lastModified, userTimeZone) : "-"}</Caption1>, },
                status: { label: <Caption1> {val.status != null ? val.status : "Draft"} </Caption1>, },
              })
              :
              accumulator.push({
                checkbox: "hide",
                name: {
                  label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                    <Button shape="circular" style={buttonContent} appearance="transparent" size="small"> {val.packageName !== null ? val.packageName : 'N/A'}</Button></Tooltip>
                  , id: `${i}`
                },
                description: { label: <Caption1 > {val.packageDesc != "" ? val.packageDesc : 'N/A'} </Caption1>, status: "" },
                version: { label: <Caption1> {val.version} </Caption1>, },
                os: { label: <Caption1> {val.platform} </Caption1>, },
                created_on: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertUTCToReadableFormat(val.creationTime) : '-'} </Caption1>, },
                created_on_timezoned: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertToLocalTimezone(val.creationTime, userTimeZone) : '-'} </Caption1>, },
                modified_on: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertUTCToReadableFormat(val.lastModified) : "-"}</Caption1>, },
                modified_on_timezoned: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertToLocalTimezone(val.lastModified, userTimeZone) : "-"}</Caption1>, },
                status: { label: <Caption1> {val.status != null ? "Draft" : "Draft"} </Caption1>, },
              })
          }
        }
        setTotalRecords(accumulator?.length)
        return accumulator;
      }, [])
      : [];
    setTableData(updatedTempTableData);
    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
      if (isRefresh) {
        console.log("FIRST CALL");
        setIsRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
        setRefreshToast(false);
        }, 3000);
    }
    }, 500);
  }, [final_data, rowID, permissions]);

  //////////////////////////////first page datatable ends here/////////////////////
  useEffect(() => {
    // Overlay device table values append code starts here
    final_data2 !== undefined && final_data2 !== null
      ? final_data2 && final_data2.map((val: any) => {
        const deviceData = val && val.classificationName
        return <Caption1>{deviceData} </Caption1>;
      }) : (console.log("null"));
  }, [final_data2]);

  useEffect(() => {
    if (final_data3) {
      const deviceStatusMap: any = {};
      final_data3.communication_Audit.forEach((entry: any) => {
        const { MachineTag, JobStatus, ClientExecutedTime } = entry;
        if (!deviceStatusMap[MachineTag]) {
          deviceStatusMap[MachineTag] = { JobStatus, ClientExecutedTime };
        }
      });
      setDeviceDataWithStatus(deviceStatusMap);
    }
  }, [final_data3]);

  //////////////////////////ends here////////////////////////////////
  useEffect(() => {
    // Overlay data table values append code starts here
    final_data1 !== undefined && final_data1 !== null
      ? final_data1?.map((val: any, i: any) => {
        var deviceStatus: any = machineStatus && machineStatus[`${val.host}`] ? machineStatus[`${val.host}`][0] : 'offline';
        var deviceType: any = machineStatus && machineStatus[`${val.host}`] ? machineStatus[`${val.host}`][1] : 'default';
        var currentIcon = <Badge size="extra-small" appearance="filled" color={deviceStatus === 'online' ? "success" : "informative"} > </Badge>;

        if (deviceStatus === 'online') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/G_Win.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/G_Android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/G_Apple.svg" alt="Analyze Icon" />;
          }
        } else if (deviceStatus === 'offline') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/Windows.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/apple.svg" alt="Analyze Icon" />;
          }
        }

        tempTableData.push({
          id: val.host,
          host: { label: <Caption1> {val.host} </Caption1>, icon: currentIcon, id: `${i}` },
          site: { label: <Caption1> {val.site} </Caption1>, status: "" },
          os: { label: <Caption1> {val.os} </Caption1>, }
        });
      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData1(tempTableData) : setTableData1([]);
    // setLoading(false);
  }, [final_data1, machineStatus]);

  ////////////////////////////////ends here/////////////////////////////////
  useEffect(() => {
    // Overlay data table values append code starts here
    final_data1 !== undefined && final_data1 !== null
      ? final_data1?.map((val: any, i: any) => {
        const deviceData = val && val.host;
        const jobStatus = deviceDataWithStatus[deviceData]?.JobStatus;
        let executeTime = deviceDataWithStatus[deviceData]?.ClientExecutedTime || '-';
        if (executeTime != "-") {
          const convertedTime = new Date(executeTime * 1000);
          executeTime = convertedTime.toLocaleString();
        }
        // <Caption1>{deviceData} - {jobStatus}</Caption1>;
        var deviceStatus: any = machineStatus && machineStatus[`${val.host}`] ? machineStatus[`${val.host}`][0] : 'offline';
        var deviceType: any = machineStatus && machineStatus[`${val.host}`] ? machineStatus[`${val.host}`][1] : 'default';
        var currentIcon = <Badge size="extra-small" appearance="filled" color={deviceStatus === 'online' ? "success" : "informative"} > </Badge>;

        if (deviceStatus === 'online') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/G_Win.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/G_Android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/G_Apple.svg" alt="Analyze Icon" />;
          }
        } else if (deviceStatus === 'offline') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/Windows.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/apple.svg" alt="Analyze Icon" />;
          }
        }

        tempTableData1.push({
          checkbox: "hide",
          id: val.host,
          device_name: { label: <Caption1>{deviceData}</Caption1>, id: `${i}` },
          deployement_status: { label: <Caption1>{(jobStatus == 2) ? "success" : (jobStatus == 3) ? "failed" : "pending"} </Caption1> },
          date: { label: <Caption1>{executeTime} </Caption1>, status: "" },
        });
      }) : (tempTableData1 = []);

    tempTableData1.length > 0 ? setTableData2(tempTableData1) : setTableData2([]);
    // setLoading(false);
  }, [final_data1, machineStatus, deviceDataWithStatus]);

  var overLayData: any = {
    //here this is heading of the overlay
    headerTitle: <Title3>{pacakgeName}</Title3>,
    size: "large",
    isTabs: true,
    //this is button present in the overlay
    footerData:
      (
        <>
          {/* <Button shape="circular" appearance="primary" onClick={() => { setmessagebar1(true); }} disabled={isSaveEnabled ? false : true}> Deploy App </Button> */}
          <DialogBox
            headerButton=
            {
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>
                  <Button shape="circular" appearance="primary" onClickCapture={() => {setPending(false); setCurrentPageNo(1); setmessagebar1(true) }} disabled={isSaveEnabled ? false : true}>  Deploy App </Button>
                </StackItem>
                <StackItem>
                  <Button shape="circular" appearance="primary" onClick={() => { setPending(true) }}> Clear pending queue </Button>
                </StackItem>
              </Stack>
            }

            content={pending ? "Are you sure you want to proceed with clearing pending jobs" : `Are you sure you want to proceed with publishing this app on ${contextValue.selectedRowIdInTable.length} devices?`}

            footer=
            {
              <>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <StackItem>
                    {!pending ? <Button shape="circular" appearance="primary" size="small" onClick={handleBothSetMessage} onClickCapture={() => {pending && contextValue.setSelectedRowIdInTable([]); setButtonEnabled(false);}}> Confirm </Button> : <Button shape="circular" appearance="primary" size="small" onClick={handlePendingMessages}> Confirm </Button>}
                  </StackItem>
                  <StackItem>
                    <Button shape="circular" size="small" onClick={() => { setPending(false) }}>Cancel</Button>
                  </StackItem>
                </Stack>
              </>
            }
          />
        </>
      ),

    //data presents in the overlay(overlay content)
    tabItems: {

      Introduction: spinnerLoad ?
        <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner />
        </Stack> :
        <FluentProvider theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 15, padding: "10px 0px 0px 0px" }}>
            <Form disabled formData={formDataPkg}
              schema={jsonSchemaPkg}
              uiSchema={uiSchemaPkg}
              validator={validator}
              widgets={CustomWidgets}
              onChange={(e) => setFormDataPkg(e.formData)} />
          </Stack>
        </FluentProvider>,
      Configuration:
        <FluentProvider theme={dashboardTheme}>
          <Stack>
            <Body1Strong>App Configurations</Body1Strong>
            <Form id="appinstallation" disabled={true} formData={formDataApp} schema={jsonSchemaApp} uiSchema={uiSchemaApp} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataApp(e.formData)} />
          </Stack>
          <Body1Strong>Advance Configurations</Body1Strong>
          <Stack horizontal tokens={{ childrenGap: 157, padding: 5 }}>
            <Form disabled={true} formData={formDataAdv} schema={jsonSchemaAdv} uiSchema={uiSchemaAdv} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataAdv(e.formData)} />
          </Stack>
        </FluentProvider>,
      Deploy:
        <>

          <Stack id="troubleshootContainer" style={oveyAlignment} horizontalAlign="start">
            <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 10 }} horizontal>
              <StackItem style={oveyAlignment} grow shrink>
                {/* <Card> */}
                <StackItem style={oveyAlignment}>
                  <Stack horizontal >
                    <Stack verticalFill>
                      <StackItem><Text></Text></StackItem>
                      {/* <StackItem> <Body1Strong>Data Classification</Body1Strong> </StackItem> */}
                      <StackItem> <Body1Strong>Devices Classification</Body1Strong> </StackItem>
                      <Stack tokens={{ childrenGap: 10 }}>
                        <StackItem><Text></Text></StackItem>
                        <StackItem><Divider /></StackItem>
                      </Stack>
                    </Stack>
                  </Stack>
                  <Divider/>
                  <Stack style={overlayResponsive}>
                    <StackItem style={tableDiv}>
                      <StackItem onClick={() => { setGroupName(""); setLoadingDevice(true); setallDevice(true); contextValue.setSelectedRowIdInTable([]); }}>
                        <FluentProvider theme={groupName === "" ? lightTheme : undefined}>
                          <MenuItem> All Devices</MenuItem>
                        </FluentProvider>
                      </StackItem>
                      <Stack verticalFill>
                        {final_data2 !== undefined && final_data2 !== null
                          ? final_data2 && final_data2.map((val: any) => {
                            const deviceData = val.classificationName;
                            return <StackItem onClick={() => { setGroupName(deviceData); setLoadingDevice(true); setGroupName(deviceData); setallDevice(false); contextValue.setSelectedRowIdInTable([]); }} >
                              <FluentProvider theme={groupName === deviceData ? lightTheme : undefined}>
                                <MenuItem><Body1> {deviceData} </Body1></MenuItem>
                              </FluentProvider>
                            </StackItem>;
                          }) : (console.log("null"))
                        }
                      </Stack>
                    </StackItem>
                  </Stack>
                </StackItem>
              </StackItem>

              <Divider vertical />

              <StackItem style={DynamicBoxingCSS}>
                {/* RIGHT SIDE DATA HERE */}
                <InfoBar showSpaces={true} title={"Try changing or adding filters if you don't see what you're looking for."} />

                <StackItem>
                  <Stack wrap horizontal tokens={{ childrenGap: 20 }}>
                    <StackItem>
                      <SearchBar columnSearch={"for Device Name"} searchVal={searchDevVal} setSearchVal={setSearchDevVal} setLoading={setLoadingDevice} disabled={loadingDevice || tableData1.length === 0} />
                      {/* <SearchBox onChange={(e: any) => { setSearchDevVal(e.target.value); }} placeholder="Search" size="small" /> */}
                    </StackItem>
                    <StackItem>
                      <MenuDropdown open={filterMenuOpenOverlay} btn={
                        <MenuButton disabled={loadingDevice || tableData1.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpenOverlay(true)}>
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <FilterAdd20Filled {...(loadingDevice || tableData1.length === 0 ? secondaryIcon : primaryIcon)} />
                            <Body1> Filter </Body1>
                          </Stack>
                        </MenuButton>
                      } itemVal={
                        <>
                          <Body1Strong> Add a Filter </Body1Strong>
                          <Divider />
                          <MenuList>
                            <Stack tokens={{ childrenGap: 5 }}>
                              <StackItem> <Text></Text> </StackItem>
                              <StackItem> <Caption1> Filter </Caption1> </StackItem>
                              <DropdownComponent optionData={overlayColumns} setDropDownValue={(newValue) => { setDropDownValue1Overlay(newValue); setDropDownValue2Overlay(''); }} dropDownvalue={dropDownValue1Overlay} />
                              <StackItem> <Divider /> </StackItem>
                              <StackItem> <Caption1> Value </Caption1> </StackItem>
                              {dropDownValue1Overlay === "Operating System" && (overlayFilterArray.some(filter => filter.startsWith(`${dropDownValue1Overlay} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2Overlay} dropDownvalue={dropDownValue2Overlay} />))}
                              {dropDownValue1Overlay === "Device Name" && (overlayFilterArray.some(filter => filter.startsWith(`${dropDownValue1Overlay} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size='small' onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />))}
                              <StackItem>
                                <Divider />
                              </StackItem>
                              <Stack tokens={{ childrenGap: 10 }} horizontal>
                                <StackItem>
                                  <Button shape="circular" appearance="primary" onClick={() => { handleOverlayFilter(); setFilterMenuOpenOverlay(false); setLoadingDevice(true); }}
                                    disabled={!dropDownValue1Overlay || !dropDownValue2Overlay || overlayFilterArray.includes(`${dropDownValue1Overlay}:`)}>
                                    <Caption1> Apply </Caption1>
                                  </Button>
                                </StackItem>
                                <StackItem>
                                  <Button shape="circular" onClick={() => { setFilterMenuOpenOverlay(false); setLoadingDevice(false); }}>     <Caption1> Cancel </Caption1>
                                  </Button>
                                </StackItem>
                              </Stack>
                            </Stack>
                          </MenuList>
                        </>}
                      />
                    </StackItem>

                    <StackItem>
                      {overlayFilterArray.length > 0 && overlayFilterArray.map((item, index) => (
                        <Button shape="circular" size="small">
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {item} </StackItem>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 1 }}>
                                <StackItem><Text></Text></StackItem>
                                <StackItem><Dismiss16Regular onClick={() => { handleCloseOverlayFilter(index); setLoadingDevice(true); }} /></StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        </Button>
                      ))}
                    </StackItem>
                    <StackItem onClick={() => { setOverlayFilterArray([]); setIsOverlayFilter(false); setDropDownValue2(''); setOverlayResetDisabled(true); setLoadingDevice(true); }}>
                      <Button shape="circular" appearance="subtle" size="small" disabled={isOverlayResetDisabled}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                          <StackItem> <FilterDismiss20Filled /> </StackItem>
                          <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                        </Stack>
                      </Button>
                    </StackItem>
                  </Stack>
                </StackItem>

                <Stack style={overlayTableHeight} tokens={{ childrenGap: 10 }}>
                  <FluentProvider style={DynamicBoxingCSS} theme={dashboardTheme}>
                    {tableData1.length > 0 && !loadingDevice && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                      <StackItem> {totalOverlayRecords > 0 && <Caption1>  Showing {((currentOverlayPageNo - 1) * 50) + 1} to {(currentOverlayPageNo * 50) > totalOverlayRecords ? totalOverlayRecords : (currentOverlayPageNo * 50)} of {totalOverlayRecords} Records </Caption1>} </StackItem>
                      <StackItem> <Pagination setLoading={setLoadingDevice} totalPages={totalOverlayPages} currentPageNo={currentOverlayPageNo} setCurrentPageNo={setCurrentOverlayPageNo} /> </StackItem>
                    </Stack>
                    }
                    {loadingDevice ? (<Stack style={DynamicBoxingCSS}><SkeletonOverlayDataTable /></Stack>) : tableData1.length > 0 ? (<Stack style={heightResponsive}><DataTable tableData={tableData1} columns={overlayColumns} /></Stack>
                    ) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}

                  </FluentProvider>
                </Stack>
              </StackItem>
            </Stack>
            {/* </Card> */}

          </Stack>
        </>,
    },
  };

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
    contextValue.setSelectedRowIdInSubTable([]);
  }, []);

  useEffect(() => {
    if (!overlayOpen) {
      setFilterArray([]);
      searchVal.length > 0 && setSearchVal("");
    }
    contextValue.setSelectedRowIdInTable([]);
    contextValue.setSelectedRowIdInSubTable([]);
  }, [overlayOpen]);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setButtonEnabled(true) : setButtonEnabled(false);
  }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
                      { name: "Manage", link: "/home" },
                      {name:"Apps", link:"/manage/apps/discoveredapps"},
                      {name:"Deploy App Install", link:"#"},
                    ]} 
                  /> 
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                <StackItem> <Text></Text> </StackItem>
                <StackItem>
                  <FluentProvider theme={dashboardTheme}>
                    <Title3> Apps | Deploy App Install </Title3>
                  </FluentProvider>
                </StackItem>
              </Stack> */}
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={ManageAppPages("Deploy App Install")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem>
                        <StackItem style={wraperStyle}>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn={
                                  <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                  <Divider />
                                  <MenuList>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem> <Text></Text> </StackItem>
                                      <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                      {/* <DropdownComponent optionData={columns}/> */}
                                      <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                      <StackItem> <Divider /> </StackItem>
                                      <StackItem> <Caption1> Value </Caption1> </StackItem>
                                      {dropDownValue1 === "Operating System" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isOsNamePage} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                      {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />))}
                                      {(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Version" || dropDownValue1 === "Status") && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />))}
                                      <StackItem> <Divider /> </StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem>
                                          <Button shape="circular"
                                            appearance="primary"
                                            onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                            disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))}
                                          >  <Caption1> Apply </Caption1> </Button> </StackItem>

                                        <StackItem>
                                          <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                            <Caption1> Cancel </Caption1>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                  </MenuList>
                                </>} />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true) }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 &&
                                // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                <Stack wrap horizontal >
                                  {filterArray.length > 0 && filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                  {/* </Stack> */}
                                </Stack>}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>

                      </StackItem >

                      <Install_Status_func
                        filterArray={filterArray}
                        data={final_data}
                        func={set_final_data}
                        func1={set_final_data3}
                        searchVal={searchVal}
                        pageNo={(currentPageNo - 1) * 50}
                        setTotalPages={setTotalPages}
                        setTotalRecords={setTotalRecords}
                        isRefresh={isRefresh}
                        setIsRefresh={setIsRefresh} setJsonDataPkg={setJsonDataPkg}
                        setUiDataPkg={setUiDataPkg}
                        deployPackageDetails={deployPackageDetails}
                        setDeployPackageDetails={setDeployPackageDetails}
                        setJsonDataApp={setJsonDataApp}
                        setRowId={setRowID}
                        rowId={rowID}
                        rowDesc={rowDesc}
                        setPushClassification={setPushClassification}
                        pushClassification={pushClassification}
                        pushClassificationType={pushClassificationType}
                        setPushClassificationType={setPushClassificationType}
                        setUiDataApp={setUiDataApp}
                        setJsonDataAdv={setJsonDataAdv}
                        setUiDataAdv={setUiDataAdv}
                        setRefreshToast={setRefreshToast}
                        handleEditData={handleEditData}
                        isFilter={isfilter}
                        dropDownValue1={dropDownValue1}
                        setIsFilter={setIsFilter}
                        dropDownValue2={dropDownValue2}
                        type={type}
                        setJobPush = {setJobPush}
                        setJobFailed = {setJobFailed}
                        tenant={tenantName}
                        setExportDetails = {setExportDetails}
                        exportBtnClicked={exportBtnClicked}
                        setExportBtnClicked={setExportBtnClicked}
                        setOverlayOpen={setOverlayOpen}
                        pendingJob={pendingJob}
                        setPending={setPending}
                        setPendingJob={setPendingJob}
                        setPreviousJob={setPreviousJob}
                        setpendingJobMessage={setpendingJobMessage}
                        setSpinnerLoad={setSpinnerLoad}
                      />
                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                      {refreshToast && <ToastComponent setmessagebar={setRefreshToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                      {pendingJobMessage && <ToastComponent setmessagebar={setIsToast} isToastEnabled={pendingJobMessage} toastIntent="success" position="top-end" title="Success" message={'Pending Deployment Cleared'} footer="" />}
                      {previousJob && <ToastComponent setmessagebar={setIsToast} isToastEnabled={previousJob} toastIntent="info" position="top-end" title="Warning" message={'Previous Deployement Pending, Clear it first'} footer="" />}
                      {jobPush && <ToastComponent  setmessagebar={setIsToast} isToastEnabled={jobPush} toastIntent="success" position="top-end" title="Success" message={'Push Successful'} footer="" />}
                      {jobFailed && <ToastComponent  setmessagebar={setIsToast} isToastEnabled={jobFailed} toastIntent="error" position="top-end" title="Error" message={'Push UnSuccessful Something went Wrong'} footer="" />}

                      <>
                        {/* <TroubleshooterDevice_fun  setIsOverlayFilter={setIsOverlayFilter} isOverlayFilter={isOverlayFilter} overlayFilterArray={overlayFilterArray}  groupData={final_data2} groupFunc={set_final_data2} data={final_data1} func={set_final_data1} searchDevVal={searchDevVal}  pageNo={0} setTotalPages={setTotalPages1} setTotalRecords={setTotalRecords1} groupName={groupName} setGroupName={setGroupName} allDevice={allDevice} overlayOpen={overlayOpen} setallDevice={setallDevice} setMachineStatus={setMachineStatus} /> */}
                        <TroubleshooterDevice_fun filterArray={filterArray} groupData={final_data2} groupFunc={set_final_data2} data={final_data1} func={set_final_data1} searchDevVal={searchDevVal} pageNo={(currentPageNo - 1) * 10} groupName={groupName} setGroupName={setGroupName} allDevice={allDevice} overlayOpen={overlayOpen} setallDevice={setallDevice} setMachineStatus={setMachineStatus} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} setLoadingDevice={setLoadingDevice} isOverlayFilter={isOverlayFilter} dropDownValue1Overlay={dropDownValue1Overlay} setIsOverlayFilter={setIsOverlayFilter} dropDownValue2Overlay={dropDownValue2Overlay} setTotalOverlayPages={setTotalOverlayPages} setTotalOverlayRecords={setTotalOverlayRecords} setCurrentOverlayPageNo={setCurrentOverlayPageNo} overlayPageNo={(currentOverlayPageNo - 1) * 10} overlayFilterArray={overlayFilterArray} selectedData={rowID} />
                      </>

                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={overLayData}
            // isNavBtn={true}
            />
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};
